import { skipToken, useQuery } from '@tanstack/react-query';

import { Boards, type GetBoardParams } from '@air/api';
import { type Board, type Workspace } from '@air/api/types';

export const BOARD_KEY = '@plugin-ui/BOARD';

export const getBoardKey = (params: UseBoardParams) => {
  return [BOARD_KEY, params];
};

export type UseBoardParams = Pick<GetBoardParams, 'ancestorCutoff' | 'includeAncestors' | 'numThumbnails'> & {
  boardId: Board['id'] | undefined;
  workspaceId: Workspace['id'] | undefined;
};

export const useBoard = (params: UseBoardParams) => {
  const { boardId, workspaceId } = params;

  return useQuery({
    queryFn:
      workspaceId && boardId
        ? () =>
            Boards.get({
              ...params,
              boardId,
              workspaceId,
            })
        : skipToken,
    queryKey: getBoardKey(params),
  });
};
